export { default as Seo } from './seo'
